export default (padding: number) => {
  return (value: number) => {
    let asString = String(value)

    while (asString.length < padding) {
      asString = 0 + asString
    }

    return asString
  }
}



// WEBPACK FOOTER //
// ./src/utils/pad.ts